import styled from 'styled-components'

export const Board = styled.div`
  height: 100%;
  overflow: auto;
  white-space: nowrap;
  padding-left: 20px;
  padding-right: 20px;
`